import React from "react";

import OnePanel from "./OnePanel";
import Text from "./Text";

const FinancialStatements = () => (
  <OnePanel title="Financial Statements">
    <Text>This section covers your financial statements.</Text>
  </OnePanel>
);

export default FinancialStatements;



// WEBPACK FOOTER //
// ./src/components/analysis/FinancialStatements.js